<template>
    <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-body">
          <h4 class="header-title mt-0 mb-1">{{$t('employment_type.form.information')}} </h4>
          <p class="sub-header"></p>

          <div class="row">

            <div class="col-12">
              <TextField 
                :placeholder="$t('employment_type.form.name.placeholder')"
                :label="$t('employment_type.form.name.label')"
                v-model="model.name"
              />
            </div>

          </div>
          
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import FormMixin from '@mixins/form'
import { required } from 'vuelidate/lib/validators'

export default {
  mixins: [ FormMixin ],
  components: {
    TextField: () => import('@components/form2/textfield')
  },
  data () {
    return {
      model:{
        name: '',
        remarks: '',
      },
    }
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  validations: {
    model:{
      name: { required }
    }
  },
  computed: {
    employment_typeID() {
      let parameters = this.parameters || {}
      return parameters.employment_typeID
    },
    submitted() {
      let parameters = this.parameters || {}
      return parameters.submitted
    },
  },
  methods: {
    fetchData() {
      let param = {}
      param.id = this.employment_typeID

      return this.$store.dispatch('employment_type/find', param)
      .then(res => {
        if (res && res.data) {
          this.model = res.data
        }
      })
    }
  },
  watch: {
    employment_typeID: function () {
      this.fetchData()
    },
    submitted: function () {
      this.fetchData()
    }
  },
  mounted() {
    if (this.employment_typeID) {
      this.fetchData()
    }
  }
}
</script>